import {
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Col, Modal, Table, Tag, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { FC } from "react";
import {
  acceptMLSRequest,
  rejectMLSRequest,
} from "../../MLSPortFolio/Services";
import mlsEndpoints from "apps/CustomerPanel/MLS/Components/MLSPortFolio/EndPoints";
import { useQueryClient } from "react-query";

const SubmittedUser: FC<{
  data: any;
  type: "send" | "recive";
  setData: any;
}> = ({ data, type, setData }) => {
  const queryClient = useQueryClient();
  const { Text } = Typography;
  const columns = [
    {
      title: "Mağaza",
      dataIndex: ["store", "storeName"],
      render: (value: string) => {
        return (
          <>
            <Text className="mobile-label" data-label="Mağaza">
              {value}
            </Text>
          </>
        );
      },
    },
    {
      title: "Adı Soyadı",
      render: (_: any, record: any) => (
        <Text
        
        >
          {type === "send"
            ? record?.portfoyUserId
              ? `${record?.portfoyUser?.name || ""} ${record?.portfoyUser?.surname || ""}`
              : record?.store?.userName || ""
            : `${record?.senderUser?.name || ""} ${data?.senderUser?.surname || ""}`}
        </Text>
      ),
    },
    {
      title: "Telefon",
      render: (_: any, record: any) => (
        <Text
       
        >
          {type === "send"
            ? record?.portfoyUserId
              ? record?.portfoyUser?.phoneNumber || ""
              : record?.store?.userPhone || ""
            : data?.senderUser?.phoneNumber || ""}
        </Text>
      ),
    },
    {
      title: "",
      render: (_: any, record: any) => (
        <Text
       
        >
          {type === "send"
            ? record?.portfoyUserId
              ? record?.portfoyUser?.eMail || ""
              : record?.store?.userEmail || ""
            : data?.senderUser?.eMail || ""}
        </Text>
      ),
    },
    {
      title: "Komisyon Oranı",
      render: () => {
        return (
          <>
            <Text className="mobile-label" data-label="Komisyon Oranı">
              {"% "+data?.pps?.commissionRate }
            </Text>
          </>
        );
        
        
      },
    },

    {
      title: "Açıklama",
      render: () => {
        return (
          <>
            <Text className="mobile-label" data-label="Açıklama">
              {data?.pps?.description || ""}
            </Text>
          </>
        );
      },
    },
    {
      title: "Durum",
      dataIndex: "invitationStatus",
      key: "status",
      render: (status: number) => (
        
         <Tag color={status === 0 ? "blue" : status === 1 ? "green" : "error"}>
           {status === 0
             ? "Bekliyor"
             : status === 1
             ? "Onaylandı"
             : "Reddedildi"}
         </Tag>
       
      ),
    },
    ...(type === "recive"
      ? [
          {
            title: "İşlemler",
            dataIndex: "invitationStatus",
            key: "status",
            render: (status: number, record: any) => {
              console.log("recordddddd",record)
              if (status === 0) {
                return (
                  <div className="!flex gap-2">
                    <MazakaButton
                      className="!bg-green-500"
                      onClick={() => {
                        confirm(record, 1);
                      }}
                      icon={<CheckOutlined className="" />}
                    >
                      Kabul Et
                    </MazakaButton>
                    <MazakaButton
                      className="!bg-red-500"
                      onClick={() => {
                        confirm(record, 2);
                      }}
                      icon={<CloseOutlined />}
                    >
                      Reddet
                    </MazakaButton>
                  </div>
                );
              }
              return <></>;
            },
          },
        ]
      : []),
  ];

  const confirm = (record: any, type: number) => {
    Modal.confirm({
      title: "Uyarı",
      icon: <ExclamationCircleOutlined />,
      content: `Bu istek ${
        type === 1 ? "kabul edilir" : "reddedilir"
      }.Onaylıyor musunuz?`,
      okText: "Onayla",
      cancelText: "Vazgeç",
      onOk: async () => {
        try {
          type === 1
            ? await acceptMLSRequest(record.id)
            : rejectMLSRequest(record.id);
          openNotificationWithIcon("default", "İşlem Başarılı");
          const allData = { ...data };
          const findUserIndex = allData?.ppsRequestItem?.findIndex(
            (user: any) => user.id === record.id
          );

          if (findUserIndex !== -1) {
            allData.ppsRequestItem[findUserIndex].invitationStatus = type;

            setData({ ...allData });
          }
          queryClient.resetQueries({
            queryKey: mlsEndpoints.getMyPortfolioAdverts,
            exact: false,
          });
          queryClient.resetQueries({
            queryKey: mlsEndpoints.getIncomingMLSRequst,
            exact: false,
          });
          queryClient.resetQueries({
            queryKey: mlsEndpoints.getOutcomingMLSRequst,
            exact: false,
          });
        } catch (error: any) {
          openNotificationWithIcon("default", error?.message);
        }
      },
    });
  };
  return (
    <>
      <Col xs={24} className="!mt-6">
        <Table columns={columns} dataSource={data?.ppsRequestItem || []} />
      </Col>
    </>
  );
};

export default SubmittedUser;
